import WizardStepPage from './WizardStepPage';

/** Step 4 — Trip services / components */
const ServicesStep = (props) => (
    <WizardStepPage
        stepKey="services"
        formData={props.formData?.services}
        onChange={props.onChange}
        errors={props.errors}
        setErrors={props.setErrors}
        basePrice={props.formData?.pricing?.base_price ?? props.formData?.packages?.base_price}
        onNewComponent={props.onNewComponent}
        onSearchExistingComponent={props.onSearchExistingComponent}
        tripCurrency={props.tripCurrency}
    />
);

export default ServicesStep;
